import { render, staticRenderFns } from "./TelField.vue?vue&type=template&id=583b9c35"
import script from "./TelField.vue?vue&type=script&lang=js"
export * from "./TelField.vue?vue&type=script&lang=js"
import style0 from "./TelField.vue?vue&type=style&index=0&id=583b9c35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports